import React, {Component} from 'react';
import ErrorPage from '../widgets/ErrorPage';
import {connect} from 'react-redux';
import uiActions from './ui.actions';
import FancyButton from '../widgets/FancyButton';

const getProvider = () => {
	let search = window.location.search;
	search = search && search.split('?');
	search = search && search[1];
	search = search && search.split('=');
	search = search && search[1];
	return search;
};

class NoEmailPage extends Component {
	render() {
		return (
			<ErrorPage className="NotFoundPage">
				<p>
					Sorry about this! It looks like {getProvider() || 'the external provider'} did not provide
					an email address for you.
				</p>
				<p>
					Please try again, or use an email address and password to{' '}
					<FancyButton onClick={this.props.signup}>Sign up</FancyButton>
				</p>
				<p>
					Please let our{' '}
					<a href="https://b2me.zendesk.com" target="_blank" rel="noopener noreferrer">
						support team
					</a>{' '}
					know if this keeps happening.
				</p>
			</ErrorPage>
		);
	}
}

const ConnectedNoEmailPage = connect(
	() => null,
	dispatch => ({
		signup: () => dispatch(uiActions.uiModal('signup'))
	})
)(NoEmailPage);

export default ConnectedNoEmailPage;



// WEBPACK FOOTER //
// ./src/chrome/NoEmailPage.js